export default {
    UPDATE_FILTERS(state, values) {
        state.filters = values['filters']
        state.local = values['local']
        state.temperature = values['temperature']
        state.balcony = values['balcony']
    },

}